import Catch from './Error/ErrorHandler';
import { Fragment } from 'react';
import { ErrorComponentBehoerdenServer } from './Error/ErrorComponent';
type Props = {
  children: React.ReactNode;
};

export const BehErrorBoundary = Catch(function BehErrorBoundary(
  props: Props,
  error?: Error
) {
  if (error) {
    return <ErrorComponentBehoerdenServer />;
  } else {
    return <Fragment>{props.children}</Fragment>;
  }
});
